import React, { useEffect, useState } from 'react';
import classes from "./SubscribePage2.module.css";
import { checkSubscriptionApi, getProductListApi, heApi, printLogsApi, sendOTPApi } from '../Http/http';
import Loader from '../Components/Loader';
import { FaCheck } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from "js-cookie";
import { FaHome, FaGamepad } from "react-icons/fa";
import { v4 as uuidv4 } from 'uuid';

const SubscribePage2 = () => {

    const [packs, setPacks] = useState([]);
    const [pack, setPack] = useState(null);
    const [loading, setLoading] = useState(true);
    const [msisdn, setMsisdn] = useState("");

    const [extRef, setExtRef] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        console.log(searchParams.get("ext_id"), 'ext_id===');
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } 
        else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const [modal, setModal] = useState(false);

    const [loading2, setLoading2] = useState(false);

    const navigate = useNavigate();

    const fetchProductList = async () => {
        try {
            setLoading(true);
            const response = await getProductListApi();
            console.log("Product List:", response.data?.result?.data);
            setPacks(response.data?.result?.data || []);
            setPack(response.data?.result?.data[0]?.serviceId || null);

            await fetchMsisdn()

            setLoading(false);

        } catch (error) {
            setLoading(false);
            toast.error("Something Went Wrong. Please Refresh the Page!");
            console.error("Error fetching product list:", error);
        }
    }

    const fetchMsisdn = async () => {
        try {
            const response = await heApi();
            const response2 = await printLogsApi({
                data: response
            })
            console.log(response, 'response===');

            if (/^\d{7,15}$/.test(response.data)) {
                setMsisdn(response.data);
                // await handleSubmit2(response.data);
            } else {
                console.warn("Msisdn Not Found!", response.data);
            }

            // await handleSubmit2(response?.data);
        } catch (error) {
            throw new error;
        }
    }

    useEffect(() => {
        if (Cookies.get("msisdn")) {
            navigate("/home");
        }
    }, []);

    useEffect(() => {
        fetchProductList();
    }, []);

    const handleSubmit = async () => {
        try {
            let msisdnWithCountryCode = msisdn;
            if (msisdnWithCountryCode.startsWith('0')) {
                msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
            }
            if (!msisdnWithCountryCode.startsWith('880')) {
                msisdnWithCountryCode = '880' + msisdnWithCountryCode;
            }
            setLoading2(true);

            const responseLogin = await checkSubscriptionApi({ msisdn: msisdnWithCountryCode });

            if (responseLogin?.data?.result?.statusCode == 200) {
                Cookies.set("msisdn", msisdnWithCountryCode, {
                    expires: 30,
                });
                toast.success("You are already subscribed!");
                navigate("/home");
                return;
            }

            // const responseProducts = await getProductListApi();
            // console.log("Product List:", response.data?.result?.data);
            // setPacks(response.data?.result?.data || []);

            const response = await sendOTPApi({
                MSISDN: msisdnWithCountryCode,
                ServiceId: pack
            });

            console.log(response, 'response===');

            const response2 = await printLogsApi({
                data: response?.data
            })

            setLoading2(false);

            if (response?.data?.statusCode == 200 && response?.data?.message == 'Successfull') {
                console.log("OTP sent successfully");
                navigate("/otp", {
                    state: {
                        msisdn: msisdnWithCountryCode,
                        pack: pack,
                        extRef: extRef
                    }
                })
            }
            else if (response?.data?.statusCode == 500) {
                toast.error(response?.data?.message);
            }
            else {
                toast.error(response?.data?.message || "Failed to send OTP. Please try again.");
            }

        } catch (error) {

            const errMsg = error?.response?.data?.error
                || "Something went wrong. Please try again.";

            toast.error(errMsg);

            const response2 = await printLogsApi({
                data: error
            })

            setLoading2(false);
        }
    }

    // const handleSubmit2 = async (msisdnFromHE) => {
    //     try {
    //         let msisdnWithCountryCode = msisdnFromHE;
    //         if (msisdnWithCountryCode.startsWith('0')) {
    //             msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
    //         }
    //         if (!msisdnWithCountryCode.startsWith('880')) {
    //             msisdnWithCountryCode = '880' + msisdnWithCountryCode;
    //         }
    //         setLoading2(true);

    //         const responseLogin = await checkSubscriptionApi({ msisdn: msisdnWithCountryCode });

    //         if (responseLogin?.data?.result?.statusCode == 200) {
    //             Cookies.set("msisdn", msisdnWithCountryCode, {
    //                 expires: 30,
    //             });
    //             toast.success("You are already subscribed!");
    //             navigate("/home");
    //             return;
    //         }

    //         // const responseProducts = await getProductListApi();
    //         // console.log("Product List:", response.data?.result?.data);
    //         // setPacks(response.data?.result?.data || []);

    //         const response = await sendOTPApi({
    //             MSISDN: msisdnWithCountryCode,
    //             ServiceId: pack
    //         });

    //         console.log(response, 'response===');

    //         const response2 = await printLogsApi({
    //             data: response?.data
    //         })

    //         setLoading2(false);

    //         if (response?.data?.statusCode == 200 && response?.data?.message == 'Successfull') {
    //             console.log("OTP sent successfully");
    //             navigate("/otp", {
    //                 state: {
    //                     msisdn: msisdnWithCountryCode,
    //                     pack: pack
    //                 }
    //             })
    //         }
    //         else if (response?.data?.statusCode == 500) {
    //             toast.error(response?.data?.message);
    //         }
    //         else {
    //             toast.error(response?.data?.message || "Failed to send OTP. Please try again.");
    //         }

    //     } catch (error) {

    //         const errMsg = error?.response?.data?.error
    //             || "Something went wrong. Please try again.";

    //         toast.error(errMsg);

    //         const response2 = await printLogsApi({
    //             data: error
    //         })

    //         setLoading2(false);
    //     }
    // }

    const handlePopUp = async () => {
        if (msisdn.trim().length != 0) {
            setModal((prevValue) => !prevValue);
        }
    }
    return (
        <div className={classes.container}>
            <div className={classes.section_hero}>

                <div className={classes.header}>
                    <div className={classes.slider_content} style={{ justifyContent: "flex-start", alignItems: "flex-start" }}>
                        <h2 className="tlt fix" style={{ textAlign: "left" }} data-in-effect="fadeInLeft">Door<span> 2 </span>Games</h2>
                    </div>

                    <div className={classes.header_menu}>
                        <div className={classes.menu_icon_container}
                            onClick={() => navigate("/")}
                        >
                            <FaHome className={classes.menu_icon} />
                            <p className={classes.menu_text}>Home</p>
                        </div>
                        <div className={classes.menu_icon_container}
                            onClick={() => navigate("/")}

                        >
                            <FaGamepad className={classes.menu_icon} />
                            <p className={classes.menu_text}>Games</p>
                        </div>

                        <button type="button" className={classes.login_button} onClick={() => navigate("/login")}>
                            Login
                        </button>
                    </div>
                </div>

                <div className={classes.subscription_form}>
                    {loading ? <Loader /> : (
                        <>
                            <div className={classes.price_container}>
                                <p className={classes.price_desc}>Join for only BDT 5.05</p>
                                <p className={classes.price_desc2}>(including all taxes, auto-renewable)</p>
                            </div>
                            <h3 className={classes.title}>Enter your mobile number</h3>
                            {/* <p className={classes.info}>(Including all taxes + auto renewable)</p> */}
                            <div className={classes.input_container}>
                                <span className={classes.icon}>📱</span>
                                <span className={classes.prefix}>+880</span>
                                <input type='number' placeholder='Enter your Number'
                                    className={classes.input}
                                    value={msisdn}
                                    onChange={(e) => setMsisdn(e.target.value)}
                                />
                            </div>

                            <button className={classes.next_button} onClick={handlePopUp} disabled={loading2}>
                                {loading2 ? "Loading..." : "Continue"}
                            </button>
                        </>
                    )}

                </div>

                <div className={classes.slider_content}>
                    {/* <h2 className="tlt fix" data-in-effect="fadeInLeft">Door<span> 2 </span>Games</h2> */}
                    <p>© {new Date().getFullYear()} Door2Games. All Rights Reserved</p>
                    <p><strong>Email:</strong> <a href="mailto:support@cloud7bd.com" className={classes.link}>support@cloud7bd.com</a></p>
                    <p><strong>Helpline:</strong> <a href="tel:8801957931782" className={classes.link}>01957931782</a></p>
                </div>

            </div>

            {modal && <div className={classes.modal}>

                <div className={classes.modal_container}>
                    <div className={classes.price_container}>

                        <p className={classes.price_desc}>Everyday for only BDT 5.05</p>
                        <p className={classes.price_desc2} style={{ textAlign: "center" }}>(including all taxes, auto-renewable).</p>

                    </div>
                    <div className={classes.input_container} style={{ boxShadow: "0 10px 20px rgba(0,0,0,0.4)" }}>
                        <span className={classes.icon}>📱</span>
                        <span className={classes.prefix}>+880</span>
                        <input type='number' placeholder='Enter your Number'
                            className={classes.input}
                            value={msisdn}
                            disabled={true}
                            onChange={(e) => setMsisdn(e.target.value)}
                        />
                    </div>

                    <div className={classes.buttons_container}>
                        {loading2 ? <div className={classes.loader}>
                            <Loader />
                        </div> : (
                            <>
                                <button type="button" disabled={loading2} onClick={() => setModal(false)} className={classes.no_button}>
                                    No
                                </button>
                                <button type="button" disabled={loading2} className={classes.yes_button}
                                    onClick={handleSubmit}
                                >
                                    {loading2 ? "Loading..." : "Yes"}
                                </button>
                            </>
                        )}
                    </div>
                </div>

            </div>}
        </div>


    )
}

export default SubscribePage2;


const profileImages = [
    "/assets/game-images/crazy_match3_512x512.png",
    "/assets/game-images/danger%20runing.png",
    "/assets/game-images/delta_512x512.png",
    "/assets/game-images/double_stickman_512x512.png",
    "/assets/game-images/dragonjump_512x512.png",
    "/assets/game-images/duckshooter_512x512.png",
    "/assets/game-images/emoji%20squeeze.png",
    "/assets/game-images/faces_match_512x512.png",
    "/assets/game-images/feed.png",
    "/assets/game-images/fishnjump_512x512.png",
    "/assets/game-images/flying%20boy.png",
    "/assets/game-images/follow_line_512x512.png",
    "/assets/game-images/Aliens_Memory_512x512.png",
    "/assets/game-images/AngryCatShot_512x512.png",
    "/assets/game-images/AnimalFun_512x512.png",
    "/assets/game-images/BrickDodge_512x512.png",
    "/assets/game-images/CholiJet_512x512.png",
    "/assets/game-images/DangerousCircle_512x512.png",
    "/assets/game-images/Dark_Ninja_512x512.png",
    "/assets/game-images/Emoji_Pong_512x512.png"
];
